/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";

import img from ".././../../assets/images/edushala.png";
// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress"; // 👈 MUI Loader

// Image
const bgImage =
  "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg";

// baseUrl
import axios from "utils/api";
function Illustration() {
  const [rememberMe, setRememberMe] = useState(false);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const navigate = useNavigate();

  // handleLogin
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [loading, setLoading] = useState(false); // 👈 loader state

  // const handleLogin = (e)=>{
  //   e.preventDefault();
  //   console.log(email)
  //   console.log(password)

  //   fetch(`${baseURL}/user/login`,{
  //     method:"POST",
  //     headers:{
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({email,password}),
  //   }).then((res)=>res.json())
  //   .then((result)=>{
  //     console.log(result)
  //   }).catch((err)=>{
  //     console.log(err)
  //   })
  // }

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true); // loader start
    console.log("Login attempt:", { email, password });
    axios
      .post("/user/login", { email, password })
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          const { token, refreshToken, user } = res.data.data;
          // localStorage mai save karana
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("user", JSON.stringify(user));

          // ✅ Toast success
          toast.success(res.data.message);
          console.log("login successfully", user);

          if (user.role === "SUPER_ADMIN") {
            localStorage.setItem("allowedPermissions", JSON.stringify(["ALL"]));
            navigate("/dashboard");
          } else if (user.role === "ADMIN") {
            localStorage.setItem("allowedPermissions", JSON.stringify(user.permissions));
            navigate("/");
          } else {
            console.log("Login failed", res.data.message);
            // ✅ Toast error
            toast.error(res.data.message || "Login failed!");
          }
          // ✅ Dono role ke liye ek hi navigate
          // navigate("/dsfsdfs");
        }
      })
      .catch((err) => {
        console.log(err);
        // toast.error("Something went wrong, please try again.")
        // ✅ Agar API se response aya hai
        if (err.response) {
          const message = err.response.data?.error || "Unauthorized access!";
          toast.error(message);
        }
      })
      .finally(() => {
        setLoading(false); // loader stop
      });
  };

  return (
    <IllustrationLayout
      title="Sign In"
      description="Enter your email and password to sign in"
      illustration={{
        // image:img,
        image: bgImage,
        title: '"Attention is the new currency"',
        description:
          "The more effortless the writing looks, the more effort the writer actually put into the process.",
      }}
    >
      <ArgonBox component="form" role="form">
        <ArgonBox mb={2}>
          <ArgonInput
            type="email"
            placeholder="Email"
            size="large"
            value={email}
            onChange={(e) => {
              return setemail(e.target.value);
            }}
          />
        </ArgonBox>
        <ArgonBox mb={2}>
          <ArgonInput
            type="password"
            placeholder="Password"
            size="large"
            value={password}
            onChange={(e) => {
              return setpassword(e.target.value);
            }}
          />
        </ArgonBox>
        <ArgonBox display="flex" alignItems="center">
          {/* <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <ArgonTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </ArgonTypography> */}
        </ArgonBox>
        <ArgonBox mt={1} mb={1}>
          <ArgonButton
            disabled={loading}
            onClick={handleLogin}
            variant="contained"
            color="primary"
            size="large"
            fullWidth
          >
            {/* Sign In */}
            {loading ? <CircularProgress size={24} color="inherit" /> : "Sign In"}
          </ArgonButton>
        </ArgonBox>
        <ArgonBox mt={3} textAlign="center">
          {/* <ArgonTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <ArgonTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="info"
              fontWeight="medium"
            >
              Sign up
            </ArgonTypography>
            
          </ArgonTypography> */}
        </ArgonBox>
      </ArgonBox>
    </IllustrationLayout>
  );
}

export default Illustration;
